module.exports = __webpack_public_path__ + "media/stylesheets/images/favicon-008477e4eb48fa963c4036fecc64093c.ico";